// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"696f5ad3","311":"696f5ad3","834":"694ef98c","912":"38e3ed17","966":"18151714"}[chunkId] + ".chunk.css";
};